var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconScheduleBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_schedule_balance",
    transform: "translate(-125 -595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1519",
    "data-name": "Group 1519",
    transform: "translate(-225.76 18183.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6",
    "data-name": "Subtraction 6",
    d: "M9.366,23H2a2,2,0,0,1-2-2L.01,4A2,2,0,0,1,2,2H3V0H5V2H21V0h2V2h1a2,2,0,0,1,2,2v7.015a10.457,10.457,0,0,0-2-1.531V6H2V21H8.443a9.7,9.7,0,0,0,.922,2Z",
    transform: "translate(350.76 -17588.32)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1149",
    "data-name": "Line 1149",
    d: "M0,0H17.928",
    transform: "translate(355.907 -17575.049)",
    fill: "none",
    stroke: "#666",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_236",
    "data-name": "Polygon 236",
    d: "M5.252,0,10.5,5.467H0Z",
    transform: "translate(359.621 -17574.502)",
    fill: "#0000b5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2321",
    "data-name": "Rectangle 2321",
    width: 3,
    height: 3,
    transform: "translate(131.826 604.598) rotate(1)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2322",
    "data-name": "Rectangle 2322",
    width: 3,
    height: 3,
    transform: "translate(143.299 604.65)",
    fill: "#0000b5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScheduleBalance);
export default __webpack_public_path__ + "static/media/icon_schedule_balance.9d0b27c60feca6d423794c0912e8d135.svg";
export { ForwardRef as ReactComponent };